import React from "react";
import { Wrapper, Container } from "./styles";

const ModalStickyFooter = ({
  children,
  styles,
  dStyles,
  hideShadow
}: {
  children: any;
  styles?: any;
  dStyles?: any;
  hideShadow?: boolean;
}) => {
  return (
    <Wrapper $hideShadow={hideShadow}>
      <Container styles={styles} dStyles={dStyles}>
        {children}
      </Container>
    </Wrapper>
  );
};

export default ModalStickyFooter;
